module.exports = require('./getLayoutVarsFromApps')
